<div class="email-sent-body">
  <div class="email-sent-container">
    <div fxLayout="row" fxLayoutAlign="center center" class="content">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Magic Link kiküldve</mat-card-title>
        </mat-card-header>
        <mat-card-content class="email-sent-card-content">
          <p>Ellenőrizze az e-mail fiókjában, hogy megkapta a Magic Link-et.</p>
          <p>Kattintson a Magic Link-re a bejelentkezéshez.</p>
          <p>Ha nem kapta meg az e-mailt, ellenőrizze a spam mappát.</p>
          <p>Ha még így sem kapta meg az e-mailt, akkor <a href="/login">kérjen új Magic Link-et</a>.</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>